export default {
    name: "catalogs",
    component: () => import(/* auth-router-module */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: "programs",
            name: "admin-programs-index",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Programas"
            },
            component: () => import('@/modules/catalogs/views/ProgramsList.vue')
        },
        {
            path: "programs/new",
            name: "admin-programs-new",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Crear programa"
            },
            component: () => import('@/modules/catalogs/views/ProgramForm.vue')
        },
        {
            path: "programs/:id/edit",
            name: "admin-programs-edit",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Editar programa"
            },
            component: () => import('@/modules/catalogs/views/ProgramForm.vue')
        },
        {
            path: "trainings",
            name: "admin-trainings-index",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Capacitaciones"
            },
            component: () => import('@/modules/catalogs/views/TrainingsList.vue')
        },
        {
            path: "trainings/new",
            name: "admin-trainings-new",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Crear capacitación"
            },
            component: () => import('@/modules/catalogs/views/TrainingForm.vue')
        },
        {
            path: "trainings/:id/edit",
            name: "admin-trainings-edit",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Editar capacitación"
            },
            component: () => import('@/modules/catalogs/views/TrainingForm.vue')
        },
        {
            path: "counselings",
            name: "admin-counselings-index",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Acompañamientos"
            },
            component: () => import('@/modules/catalogs/views/CounselingsList.vue')
        },
        {
            path: "counselings/new",
            name: "admin-counselings-new",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Crear acompañamiento"
            },
            component: () => import('@/modules/catalogs/views/CounselingForm.vue')
        },
        {
            path: "counselings/:id/edit",
            name: "admin-counselings-edit",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Editar acompañamiento"
            },
            component: () => import('@/modules/catalogs/views/CounselingForm.vue')
        },
        {
            path: "company-managers",
            name: "admin-company-managers-index",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Responsables CFOSC"
            },
            component: () => import('@/modules/catalogs/views/CompanyManagersList.vue')
        },
        {
            path: "company-managers/new",
            name: "admin-company-managers-new",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Crear responsable CFOSC"
            },
            component: () => import('@/modules/catalogs/views/CompanyManagerForm.vue')
        },
        {
            path: "company-managers/:id/edit",
            name: "admin-company-managers-edit",
            meta: {
                requiresAdmin: true,
                breadcrumbs: [],
                title: "Editar responsable CFOSC"
            },
            component: () => import('@/modules/catalogs/views/CompanyManagerForm.vue')
        },
        {
            path: "contact-person",
            name: "contact-person-index",
            meta: {
                breadcrumbs: [],
                title: "Contact Person"
            },
            component: () => import('@/modules/catalogs/views/ContactPersonIndex.vue')
        }
    ]
}